module.exports = __webpack_public_path__ + "img/icon-power-white.f9ad9dad.svg";